/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-15 18:30:28
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyCheckGroup from "../BsyCheckGroup";
import BsyCheckBox from "../BsyCheckBox";
import BsyIconBtn from "../BsyIconBtn";
import BsyComboBox from "../BsyComboBox";

class BsyExportPane extends BsyWidget {
  static defaultProps = {
    fields: [],
    selectedFields: [],
    forms: [],
    relations: {},
    filter: {},
    sort: [],
    name: "",
    time: 1440,
    limit: 1000,
    authGroupId: null,
    dataNum: 0,
    isDataId: true,
    fieldIsAll: true,
    filterMode: "all",
    reftype: "form",
    exportMode: window.hasJarvisbim ? 1 : 2, // 0、图片保存在excel文件中 1、图片，附件保存在同级目录以zip压缩格式导出 2、图片附件使用超链接方式保存在excel中
  };
  constructor(props) {
    super(props);
    this.hasImage = false;
    this.uploads = []; //记录通过模式来切换选择状态
    this.images = [];
    this.fieldsItem = this.getFieldItems();
    this.options.showFields = null;
    let selectedFields = [];
    this.hasImageField = false;
    this.fieldsItem.map((data) => {
      if (data.type === "upload") {
        this.uploads.push(data.value);
      }
      if (data.type === "image" || data.type === "signature") {
        this.images.push(data.value);
      }

      if (
        data.type === "image" ||
        data.type === "signature" ||
        data.type === "upload"
      ) {
        this.hasImageField = true;
        return data;
      }
      if (data.selected !== false) {
        selectedFields.push(data.value);
      }
    });

    this.options.limit = parseInt(this.options.limit);
    this.hasDataId = false;

    this.state = {
      ...props,
      selectedFields,
      exportMode: props.exportMode,
      hasUserAccount: false,
      // hasImage: this.hasImage,
      fieldIsAll:
        this.fieldsItem.length === selectedFields.length ? true : false,
    };

    this.element = React.createRef();
    this.tooltip = React.createRef();
    this.getFormDataInfo();
    if (props.reftype !== "etl_table" && props.reftype != "aggregate_table") {
      if (this.hasImageField) {
        this.getFormExportInfo();
      }
    }
  }

  getHasImage = () => {
    const { selectedFields } = this.state;
    let has = false;
    for (let i = 0; i < this.fieldsItem.length; i++) {
      var dd = this.fieldsItem[i];
      if (
        dd.type === "image" ||
        dd.type === "signature" ||
        dd.type === "upload"
      ) {
        if (selectedFields.indexOf(dd.value) > -1) {
          has = true;
          break;
        }
      }
    }
    return has;
  };

  getFormDataInfo = () => {
    const {
      appId,
      authGroupId,
      entryId,
      forms,
      filter,
      name,
      idList,
      popupFormPath,
      extDashData,
    } = this.state;
    React.axios("/data/get_form_data_info", {
      appId,
      authGroupId,
      entryId: forms ? forms[0] : entryId,
      fields: this.getFields(),
      filter,
      idList,
      name,
      jsplatform: "React",
      rel: "and",
      sort: [],
      extDashData: extDashData,
      popupFormPath: popupFormPath,
    })
      .then((res) => {
        if (res.data.code !== 400) {
          this.setState(
            {
              dataNum: res.data.count,
            },
            () => {
              this.renderTooltip();
            }
          );
        }
      })
      .catch((res) => {
        console.error(res);
      });
  };

  getFields = () => {
    let fields = [];
    this.state.fields.filter((data, index) => {
      if (data.type === "subform") {
        let dd = { ...data };
        dd.items = [];
        data.items.map((subdata, index) => {
          if (
            this.state.selectedFields.indexOf(
              [data.name || data.tag, subdata.name || subdata.tag].join(".")
            ) > -1
          ) {
            dd.items.push({ ...subdata });
          }
        });
        if (dd.items.length > 0) {
          fields.push(dd);
        }
      } else if (
        this.state.selectedFields.indexOf(data.name || data.tag) > -1
      ) {
        fields.push(data);
      }
      return false;
    });
    return fields;
  };

  getFormExportInfo = () => {
    const {
      appId,
      authGroupId,
      entryId,
      filter,
      forms,
      idList,
      name,
      popupFormPath,
      exportMode,
      extDashData,
    } = this.state;

    if (exportMode == 2) {
      return;
    }

    // 不支持导出图片，则不走当前请求
    if (!window.FX.STATIC.VIP_PACK.export_has_pic) {
      return;
    }

    React.axios("/data/get_form_export_info", {
      appId,
      authGroupId,
      entryId: forms ? forms[0] : entryId,
      fields: this.getFields(),
      filter,
      idList,
      name,
      jsplatform: "React",
      rel: "and",
      sort: [],
      extDashData: extDashData,
      popupFormPath: popupFormPath,
    })
      .then((res) => {
        if (res.data.code !== 400) {
          this.setState(
            {
              fileMax: (res.data.max / 1024 / 1024).toFixed(2),
              fileSize: (res.data.size / 1024 / 1024).toFixed(2),
              fileExceed: res.data.size > res.data.max,
            },
            () => {
              this.renderTooltip();
            }
          );
        }
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showFields = (name) => {
    if (this.options.showFields === null) {
      return true;
    }

    let show = false;
    BsyUtils.forEach(this.options.showFields, function (a, d) {
      if (d.name === name || d.tag === name) {
        show = true;
        return false;
      }

      "subform" === d.type &&
        BsyUtils.forEach(d.items, function (a, e) {
          var f = {
            value: [d.name || d.tag, e.name || d.tag].join("."),
            text: [d.text || d.title, e.text || d.title].join("."),
            type: e.type,
          };
          if (f.value === name) {
            show = true;
            return false;
          }
        });
      if (show) {
        return false;
      }
    });
    return show;
  };

  getFieldItems = () => {
    // var a = this.options
    // , b = {};
    // this.fieldMap = {};
    const { selectedFields } = this.state;
    let that = this;
    var c = [];
    BsyUtils.forEach(this.options.fields, function (a, d) {
      if (["separator", "button", "dataload", "linkquery"].includes(d.type)) {
        return;
      }

      var e = {
        text: d.text || d.title,
        value: d.name || d.tag,
        type: d.type,
      };
      if (d.type === "image" || d.type === "signature" || d.type === "upload") {
        e.hasImage = true;
        // if (window.FX.STATIC.VIP_PACK.export_has_pic) {
        e.enable = true;
        e.selected = that.showFields(e.value);
        that.hasImage = true;
        // } else {
        //     e.enable = false;
        //     e.selected = false;
        // }
      } else {
        e.selected = that.showFields(e.value);
      }

      "subform" === d.type
        ? BsyUtils.forEach(d.items, function (a, e) {
          if (
            ["separator", "button", "dataload", "linkquery"].includes(e.type)
          ) {
            return;
          }
          var f = {
            value: [d.name || d.tag, e.name || e.tag].join("."),
            text: [d.text || d.title, e.text || e.title].join("."),
            type: e.type,
          };

          if (
            e.type === "image" ||
            e.type === "signature" ||
            e.type === "upload"
          ) {
            f.hasImage = true;
            // if (window.FX.STATIC.VIP_PACK.export_has_pic) {
            f.enable = true;
            f.selected = that.showFields(f.value);
            that.hasImage = true;
            // }
            // else {
            //     f.enable = false;
            //     f.selected = false;
            // }
          } else {
            f.selected = that.showFields(f.value);
          }
          c.push(f);
        })
        : c.push(e);
    });
    return c;
  };

  getCheckContext = (context) => {
    this.checkContext = context;
  };

  renderTooltip = () => {
    const { fileMax } = this.state;
    if (this.tooltip && this.tooltip.current) {
      window.$(this.tooltip.current).empty();

      new window.FX.Tooltip({
        type: "tooltippane",
        renderEl: window
          .$("<div/>")
          .appendTo(window.$(this.tooltip.current).empty()), //window.$(this.tooltip.current),
        width: "auto",
        widgetName: "help",
        position: "bottomLeft",
        tipWidth: 340,
        onPopContentCreate: function (i) {
          var content = window.$("<div />").appendTo(i);
          window
            .$("<div style='line-height: 20px;'/>")
            .html(
              React.language("Excel.title.tip15") +
              "<br>" +
              React.language("Excel.title.tip16") +
              "<br>"
            )
            .appendTo(content);

          window
            .$("<div style='line-height: 20px;margin-top:10px'/>")
            .html(
              React.language("Excel.title.tip14") +
              "<br>" +
              React.language("Excel.title.tip12", { max: fileMax }) +
              "<span style='color:#ee5555'>" +
              React.language("Excel.title.tip13") +
              "</span>"
            )
            .appendTo(content);
        },
      });
    }
  };

  render() {
    const {
      hasDataId,
      hasImage,
      dataNum,
      fieldIsAll,
      selectedFields,
      filterMode,
      fileExceed,
      fileSize,
      fileMax,
      reftype,
      exportMode,
      hasUserAccount,
    } = this.state;

    //window.hasJarvisbim
    let imageSelectItems = [
      {
        text: React.language("export.field.mode.0"),
        value: 0,
        selected: exportMode == 0,
      },
      {
        text: React.language("export.field.mode.1"),
        value: 1,
        selected: exportMode == 1,
      },
      {
        text: React.language("export.field.mode.2"),
        value: 2,
        selected: exportMode == 2,
      },
    ];
    if (window.hasJarvisbim) {
      imageSelectItems = [
        {
          text: React.language("export.field.mode.0"),
          value: 0,
          selected: exportMode == 0,
        },
        {
          text: React.language("export.field.mode.1"),
          value: 1,
          selected: exportMode == 1,
        },
      ];
    }

    return (
      <div className={"bsy-export-pane"} ref={this.element}>
        <div className={"title"}>
          {reftype == "etl_table" ? (
            <span>{React.language("excel.export.tip5")}</span>
          ) : reftype == "aggregate_table" ? (
            <span>{React.language("excel.export.tip23")}</span>
          ) : (
            ""
          )}
          {dataNum > 0 && (
            <div
              style={{
                color: "rgb(229, 85, 85)",
              }}
            >
              {React.language("pagination.count", { count: dataNum })}
            </div>
          )}
          <div ref={this.tooltip}></div>
        </div>

        <div
          className={"count-title"}
          style={{
            display: hasImage && exportMode != 2 ? "block" : "none",
          }}
          dangerouslySetInnerHTML={{
            __html: fileExceed
              ? React.language("excel.export.tip21", {
                size: fileSize,
                max: fileMax,
              })
              : React.language("excel.export.tip22", {
                size: fileSize,
                max: fileMax,
              }),
          }}
        ></div>

        <div className={"fields-title fields-title-bold"}>
          {React.language("export.field.select")}
        </div>
        <div className={"fields-list"}>
          <div
            className={
              "bsy-group-item bsy-check all " + (fieldIsAll ? " select " : "")
            }
            onClick={() => {
              let newSelectedFields = [];
              if (!fieldIsAll) {
                this.getFieldItems().map((data) => {
                  let enable = data.enable;
                  if (exportMode == 0 && data.type == "upload") {
                    enable = false;
                  }

                  if (!window.FX.STATIC.VIP_PACK.export_has_pic) {
                    if (
                      (exportMode === 0 || exportMode === 1) &&
                      (data.type == "upload" ||
                        data.type == "image" ||
                        data.type == "signature")
                    ) {
                      enable = false;
                    }
                  }

                  if (enable !== false) {
                    newSelectedFields.push(data.value);
                  }
                });
              }
              this.setState(
                {
                  fieldIsAll: !fieldIsAll,
                  selectedFields: newSelectedFields,
                },
                () => {
                  this.setState(
                    {
                      hasImage: this.getHasImage(),
                    },
                    () => {
                      if (this.state.hasImage) {
                        this.getFormExportInfo();
                      }
                    }
                  );
                }
              );
            }}
          >
            <i className="icon-bsy-check2"></i>
            <span>{React.language("widgetName")}</span>
          </div>
          <BsyCheckGroup
            key={"grd1" + new Date().getTime()}
            getContext={this.getCheckContext}
            items={this.fieldsItem}
            value={selectedFields}
            onItemCreate={(item, index) => {
              if (!item.hasImage || exportMode == 2) return false;

              let enable = item.enable;
              if (exportMode == 0 && item.type == "upload") {
                enable = false;
              }

              if (!window.FX.STATIC.VIP_PACK.export_has_pic) {
                if (
                  (exportMode === 0 || exportMode === 1) &&
                  (item.type == "upload" ||
                    item.type == "image" ||
                    item.type == "signature")
                ) {
                  enable = false;
                }
              }

              return (
                <div
                  className={
                    "bsy-group-item bsy-check " +
                    (enable === false ? " bsy-ui-disable " : "") +
                    (Array.isArray(selectedFields) &&
                      selectedFields.indexOf(item.value) > -1
                      ? " select "
                      : "")
                  }
                  key={"check-item-" + index}
                  onClick={() => {
                    this.checkContext._doItemClick(item);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="icon-bsy-check2"></i>
                  <span
                    title={item.text}
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}>
                    {item.text}
                  </span>
                  <span
                    title={React.language("image.no.upFlow")}
                    style={{ color: "#F5222D" }}
                  >
                    ({React.language("image.no.upFlow")})
                  </span>
                </div>
              );
            }}
            onStopEdit={(e) => {

              this.setState(
                {
                  fieldIsAll:
                    this.fieldsItem.length === e.length ? true : false,
                  selectedFields: [...e],
                },
                () => {
                  this.setState(
                    {
                      hasImage: this.getHasImage(),
                    },
                    () => {
                      if (this.state.hasImage) {
                        this.getFormExportInfo();
                      }
                    }
                  );
                }
              );
            }}
          ></BsyCheckGroup>
        </div>

        {this.hasImageField ? (
          <>
            {" "}
            <div className={"fields-title fields-title-bold"}>
              {React.language("export.field.mode")}
            </div>
            <BsyComboBox
              items={imageSelectItems}
              value={exportMode}
              onStopEdit={(e) => {
                let tmp = [...selectedFields];
                if (e == 0) {
                  for (let i = 0; i < this.uploads.length; i++) {
                    let index = tmp.indexOf(this.uploads[i]);
                    if (index != -1) {
                      tmp.splice(index, 1);
                    }
                  }
                  if (!window.FX.STATIC.VIP_PACK.export_has_pic) {
                    for (let i = 0; i < this.images.length; i++) {
                      let index = tmp.indexOf(this.images[i]);
                      if (index != -1) {
                        tmp.splice(index, 1);
                      }
                    }
                  }
                } else if (e == 1) {
                  if (!window.FX.STATIC.VIP_PACK.export_has_pic) {
                    for (let i = 0; i < this.uploads.length; i++) {
                      let index = tmp.indexOf(this.uploads[i]);
                      if (index != -1) {
                        tmp.splice(index, 1);
                      }
                    }

                    for (let i = 0; i < this.images.length; i++) {
                      let index = tmp.indexOf(this.images[i]);
                      if (index != -1) {
                        tmp.splice(index, 1);
                      }
                    }
                  }
                }

                this.setState(
                  {
                    selectedFields: tmp,
                    exportMode: e,
                  },
                  () => {
                    if (this.state.hasImage) {
                      this.getFormExportInfo();
                    }
                  }
                );
              }}
            ></BsyComboBox>
          </>
        ) : (
          ""
        )}

        <div className={"fields-footer"}>
          <div className={"left-btn-group"}>
            {this.props.isDataId ? (
              <BsyCheckBox
                {...{
                  text: React.language("export.dataId"),
                  value: hasDataId,
                }}
                onStopEdit={(e) => {
                  this.setState({
                    hasDataId: e,
                  });
                }}
              ></BsyCheckBox>
            ) : (
              ""
            )}
            <BsyCheckBox
              {...{
                text: React.language("export.userAcount"),
                value: hasUserAccount,
              }}
              onStopEdit={(e) => {
                this.setState({
                  hasUserAccount: e,
                });
              }}
            ></BsyCheckBox>
          </div>

          <div className="right-btn-group">
            <BsyIconBtn
              mode={window.mode}
              type={"edit-btn"}
              text={React.language("cancel")}
              click={(e) => {
                if (this.props.onCancel) {
                  this.props.onCancel();
                }
              }}
            />
            <BsyIconBtn
              mode={window.mode}
              text={React.language("ok")}
              type={"blue edit-btn"}
              click={(e) => {
                let fields = this.getFields();

                if (this.props.onOk) {
                  this.props.onOk({
                    appId: this.props.appId,
                    authGroupId: this.props.authGroupId,
                    entryId: this.props.entryId,
                    widgetId: this.props.widgetId
                      ? this.props.widgetId
                      : undefined,
                    fields,
                    jsplatform: "React",
                    filter: this.props.filter,
                    forms: this.props.forms,
                    hasdataid: this.state.hasDataId,
                    idList: this.state.idList,
                    name: this.props.name,
                    rel: this.props.rel,
                    popupFormPath: this.props.popupFormPath,
                    exportMode: this.state.exportMode,
                    extDashData: this.props.extDashData,
                    hasUserAccount: this.state.hasUserAccount,
                    // relations: {}
                    sort: this.props.sort,
                  });
                }
              }}
            ></BsyIconBtn>
          </div>
        </div>
      </div>
    );
  }
}

export default BsyExportPane;
